import React from 'react';
import { motion } from 'framer-motion';
import dummyProd from '../../Assets/Images/dummyProd.jpg';
import useGetHomeProducts from '../../hooks/use-get-home-product';
import { BsBookmarkHeart, BsBookmarkHeartFill } from 'react-icons/bs';
import { LuIndianRupee } from 'react-icons/lu';
import StarRatingDisplay from '../../Components/StarRatingDisplay';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function TileCard({ homeCards }) {
    const lang = useSelector((state) => state.theme.language);

    const { data: products } = useGetHomeProducts();
    const history = useHistory();

    const viewProduct = (value) => {
        history.push(`/product/${value._id}/view`);
    };

    const getProductDisplayName = (productDetails) => {
        if (lang === 'en') {
            const { productName, brandName, modelName } = productDetails || {};
            return [productName, brandName, modelName].filter(Boolean).join(' / ');
        } else if (lang === 'ta') {
            const { tProductName, tBrandName, tModelName } = productDetails || {};
            return [tProductName, tBrandName, tModelName].filter(Boolean).join(' / ');
        } else {
            const { productName, brandName, modelName } = productDetails || {};
            return [productName, brandName, modelName].filter(Boolean).join(' / ');
        }
    };

    return (
        <motion.div className="relative px-2 bg-white drop-shadow-lg py-10 w-full flex">
            {/* <motion.div
                className="w-full grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                {homeCards &&
                    homeCards?.map(
                        (card, index) =>
                            card.products.length > 0 && (
                                <motion.div
                                    key={index}
                                    className="h-auto gap-5 px-5 py-2 drop-shadow-lg bg-[white] grid grid-cols-1"
                                >
                                    <span className="font-bold text-md py-2">{card.title}</span>
                                    <motion.div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                                        {card?.products &&
                                            card?.products.map((product, i) => {
                                                return (
                                                    <motion.div className="flex flex-col gap-2">
                                                        <img
                                                            src={product?.images[0] || dummyProd}
                                                            className="object-contain h-44 w-full"
                                                        />
                                                        <span className="justify-center text-center">
                                                            {product.brandName}
                                                        </span>
                                                    </motion.div>
                                                );
                                            })}
                                    </motion.div>
                                    <span className="text-underline underline cursor-pointer text-[blue]">
                                        Shop Now
                                    </span>
                                </motion.div>
                            )
                    )}
            </motion.div> */}
            <motion.div className="grid grid-cols-1 sm:grid-cols-1 gap-5 md:gap-10 md:grid-cols-1 xl:grid-cols-4 lg:grid-cols-4">
                {products &&
                    products?.map((pro, i) => {
                        return (
                            <motion.div
                                key={i}
                                className="relative w-96 flex flex-col bg-white cursor-pointer drop-shadow-lg"
                            >
                                <motion.div
                                    className="px-2 py-2 h-60 flex flex-row justify-center"
                                    onClick={() => viewProduct(pro)}
                                >
                                    <img
                                        src={pro?.images[0]?.imageUrl}
                                        className="object-contain"
                                        alt="preview"
                                    />
                                </motion.div>
                                <motion.div
                                    className="px-2 my-1 flex-row justify-between flex items-center font-bold text-xl"
                                    onClick={() => viewProduct(pro)}
                                >
                                    <motion.div className="flex flex-row items-center">
                                        <LuIndianRupee />
                                        {pro.offerPercentage === 0
                                            ? pro.price
                                            : pro.price * (pro.offerPercentage / 100)}
                                    </motion.div>
                                    <StarRatingDisplay reviews={pro.reviews} homePage={true} />
                                </motion.div>
                                <motion.div
                                    className="px-2 my-1 flex flex-row text-black"
                                    onClick={() => viewProduct(pro)}
                                >
                                    {getProductDisplayName(pro)}
                                </motion.div>
                            </motion.div>
                        );
                    })}
            </motion.div>
        </motion.div>
    );
}
